import fetch from 'auth/FetchInterceptor'
import userService from './UserService'

const AuthService = {}

const API_URL = 'http://localhost:8080'

AuthService.login = function (data) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data
	})
}

AuthService.updateLogin = function (login, data) {
	return fetch({
		url: `/auth/login/${login}`,
		method: 'put',
		data
	})
}

AuthService.sendConfirmEmail = function (email) {
	return fetch({
		url: '/auth/confirm-email',
		method: 'post',
		headers: {
            'email': email,
			'userId': userService.getCurrentUserToConfirmEmail().userId
        },
	})
}

AuthService.validateOtp = function (otp, type) {
	return fetch({
		url: '/auth/validate-otp',
		method: 'post',
		headers: {
            'otp': otp,
			'type': type,
			'userId': userService.getCurrentUserToConfirmEmail().userId
        },
	})
}

AuthService.loginSteam = function (formData) {
	return fetch({
		url: '/auth/login/steam',
		headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
		method: 'post',
		data: formData
	})
}

AuthService.refreshToken = function (id) {
	return fetch({
		url: `/auth/refresh/${id}`,
		method: 'post',
		headers: {},
	})
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post'
	})
}

AuthService.cadastrar = function (data) {
	return fetch({
		url: '/auth/cadastros',
		method: 'post',
		data,
		headers: {
			'Content-Type': 'application/json',
			'accept': 'application/json'
		}
	})
}

export default AuthService;